// Slack webhook URL（直接指定）
const SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';

// 本番環境かどうかを判定
const isProduction = () => {
  return window.location.hostname === 'deeptell.co.jp' || 
         window.location.hostname.includes('amplifyapp.com');
};

// プロキシサーバー経由でSlackに送信（CORS回避）
const sendViaProxy = async (payload) => {
  const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
  const targetUrl = SLACK_WEBHOOK_URL;
  
  const response = await fetch(proxyUrl + targetUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify(payload)
  });
  
  return response;
};

// より確実なSlack送信（複数の方法を試す）
const sendToSlackReliable = async (payload) => {
  const methods = [
    // 方法1: API Gateway経由
    async () => {
      if (process.env.REACT_APP_API_URL) {
        const endpoint = `${process.env.REACT_APP_API_URL}/slack-notification`;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ formData: payload.formData, formType: payload.formType })
        });
        return response;
      }
      throw new Error('API URL not configured');
    },
    
    // 方法2: 簡易プロキシサーバー経由
    async () => {
      const response = await fetch('https://api.allorigins.win/raw?url=' + encodeURIComponent(SLACK_WEBHOOK_URL), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload.slackPayload)
      });
      return response;
    },
    
    // 方法3: 本番環境でのみ、Lambda関数を直接呼び出し
    async () => {
      if (isProduction()) {
        const response = await fetch('/.netlify/functions/slack-notification', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ formData: payload.formData, formType: payload.formType })
        });
        return response;
      }
      throw new Error('Not in production');
    }
  ];

  for (let i = 0; i < methods.length; i++) {
    try {
      console.log(`Trying method ${i + 1} for Slack notification...`);
      const response = await methods[i]();
      
      if (response.ok) {
        console.log(`✅ Slack notification sent successfully via method ${i + 1}`);
        return true;
      } else {
        console.warn(`Method ${i + 1} failed with status: ${response.status}`);
      }
    } catch (error) {
      console.warn(`Method ${i + 1} failed:`, error.message);
    }
  }
  
  return false;
};

// 環境に応じたAPI URLの設定
const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000/api/send-slack-notification';
  } else {
    // 本番環境ではNetlify Functionsを使用
    return '/.netlify/functions/slack-notification';
  }
};

// Helper functions
const getFormTypeIcon = (type) => {
  switch (type) {
    case 'general': return '[問合]';
          case 'materials': return '[資料]';
      case 'demo': return '[デモ]';
      case 'interview': return '[面接]';
      case 'download': return '[DL]';
      default: return '[連絡]';
  }
};

const getFormTypeName = (type) => {
  switch (type) {
    case 'general': return '一般問い合わせ';
    case 'materials': return '資料請求';
    case 'demo': return 'デモ申し込み';
    default: return 'お問い合わせ';
  }
};

const getInterestLabel = (value) => {
  const interests = {
    'quantum-ai': '量子AIソリューション',
    'finance': '金融業界向けAI',
    'manufacturing': '製造業向けAI',
    'healthcare': 'ヘルスケアAI',
    'other': 'その他'
  };
  return interests[value] || value;
};

const getBudgetLabel = (value) => {
  const budgets = {
    'under-1m': '100万円未満',
    '1m-5m': '100万円〜500万円',
    '5m-10m': '500万円〜1000万円',
    'over-10m': '1000万円以上',
    'undecided': '未定'
  };
  return budgets[value] || value;
};

const getTimelineLabel = (value) => {
  const timelines = {
    'immediate': '即座に',
    '3months': '3ヶ月以内',
    '6months': '6ヶ月以内',
    '1year': '1年以内',
    'undecided': '未定'
  };
  return timelines[value] || value;
};

export const sendContactNotificationToSlack = async (formData, type = 'general') => {
  try {
    const API_URL = getApiUrl();
    
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        type: type
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    console.log('✅ Slack notification sent successfully:', result);
    return result;

  } catch (error) {
    console.error('❌ Failed to send Slack notification:', error);
    throw new Error('Failed to send Slack notification');
  }
};

export const testSlackConnection = async () => {
  console.log('🧪 Testing Slack connection...');
  
  const testData = {
    name: 'テストユーザー',
    email: 'test@example.com',
    company: 'テスト会社',
    phone: '03-1234-5678',
    message: 'Slack通知のテストメッセージです'
  };

  return await sendContactNotificationToSlack(testData, 'general');
};